export default __webpack_public_path__ + "static/media/nhlFantasyPWRSmobile.b3305b92.png";